<script setup lang="ts">
import AppLogo from '@/components/layout/AppLogo.vue'
import UserMenu from '@/components/layout/UserMenu.vue'
import NotificationsMenu from '@/features/notifications/components/NotificationsMenu.vue'
import OrganizationSwitcher from '@/features/organizations/components/OrganizationSwitcher.vue'
</script>

<template>
  <header
    class="bg-sidebar sticky top-0 z-20 flex h-(--header-height) shrink-0 items-center justify-between border-b pr-5 pl-2"
  >
    <AppLogo size="lg" class="shrink-0" />
    <div class="flex min-w-0 items-center gap-3">
      <OrganizationSwitcher />
      <NotificationsMenu />
      <UserMenu />
    </div>
  </header>
</template>
